import { ListTemplate } from "App/Component/layout/MasterData/MasterPenjualan/Template/Template";
import { Loading, Modal } from "App/Component/ui";
import { instance3 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  formatRupiah,
  isNull,
} from "App/utils/helpers";

import React, { useContext, useState } from "react";
import { FormContext } from "../../../../context/FormContext";
import { v4 as uuidv4 } from "uuid";
import { getFasilitasByPenjualanID } from "../../../TabFasilitas/DaftarFasilitas/helpers";
import { getRikjangByPenjualanID } from "../../../TabRikjang/DaftarRikjang/helpers";
import { getJasaByPenjualanID } from "../../../TabJasa/DaftarJasa/helpers";
import { getBarangByPenjualanID } from "../../../TabBarang/DaftarBarang/helpers";

function ModalTemplate({ setShowModal }) {
  const [loading, setLoading] = useState(false);

  const { formData, setFormData } = useContext(FormContext);
  const handleClickSelect = async (row, formFilter) => {
    setLoading(true);
    if (isNull(formFilter.unit_id) || isNull(formData.dokter_id)) {
      setLoading(false);
      defaultToastError("Pilih unit atau DPJP terlebih dahulu");
    } else {
      const filterTemplate = {
        id_penjualan: formData.penjualan_id,
        id_template: row.id,
        id_kelas: formData.kelas_id,
        id_asuransi: formData.asuransi_id,
        id_gudang: formData.gudang_id,
        id_unit: formFilter.unit_id,
        id_doctor: formData.dokter_id,
        nama_doctor: formData.dokter_name,
      };
      if (isNull(formData.penjualan_id)) {
        await getTemplateWithoutPenjualanID(filterTemplate);
        setLoading(false);
        setShowModal(false);
      } else {
        await getTemplateWithPenjualanID(filterTemplate);
        setLoading(false);
        setShowModal(false);
      }
    }
  };

  const validItemArray = (arr) => {
    const _temp = [];
    arr.map((item) => {
      return _temp.push({
        ...item,
        id: uuidv4(),
        asuransi_id: formData.asuransi_id,
        total: item.qty * item.hargaCustom,
        hargaCustom2: formatRupiah(item.hargaCustom),
        diskon: 0,
        nilai_diskon: 0
      });
    });
    return _temp;
  };

  const getTemplateWithPenjualanID = async (filterTemplate) => {
    const response = await getByFilterTemplate(filterTemplate);
    if (response.state) {
      const reload = formData.reload;

      const barang = await getBarangByPenjualanID(formData.penjualan_id);
      const fasilitas = await getFasilitasByPenjualanID(formData.penjualan_id);
      const rikjang = await getRikjangByPenjualanID(formData.penjualan_id);
      const jasa = await getJasaByPenjualanID(formData.penjualan_id);

      setFormData({
        ...formData,
        reload: !reload,
        barang: barang.data,
        fasilitas: fasilitas.data,
        rikjang: rikjang.data,
        jasa: jasa.data,
      });
      defaultToastSuccess("Berhasil menggunakan template");
    } else {
      defaultToastError(response.message);
    }
  };

  const getTemplateWithoutPenjualanID = async (filterTemplate) => {
    const response = await getByFilterTemplateTanpaIdPenjualan(filterTemplate);
    if (response.state) {
      const valid = validation(response);
      if (valid.state) {
        const barang = validItemArray(response.data.barang);
        const jasa = validItemArray(response.data.jasa);
        const fasilitas = validItemArray(response.data.fasilitas);
        const rikjang = validItemArray(response.data.rikjang);
        const reload = formData.reload;
        setFormData({
          ...formData,
          barang,
          jasa,
          fasilitas,
          rikjang,
          reload: !reload,
        });

        defaultToastSuccess("Berhasil menggunakan template");
      } else {
        errorItemAdaDalamList(valid.type, valid.nama);
      }
    } else {
      defaultToastError(response.message);
    }
  };

  const validation = (response) => {
    const listBarang = response.data.barang;
    const cekBarang = cekJikaItemSudahAdaDalamList(
      listBarang,
      formData.barang,
      "id_barang",
      "id_barang"
    );
    if (cekBarang.state) {
      return {
        state: false,
        type: "Barang",
        nama: cekBarang.data.namaBarang,
      };
    }

    const listJasa = response.data.jasa;
    const cekJasa = cekJikaItemSudahAdaDalamList(
      listJasa,
      formData.jasa,
      "jasa_id",
      "jasa_id"
    );
    if (cekJasa.state) {
      return {
        state: false,
        type: "Jasa",
        nama: cekJasa.data.namaJasa,
      };
    }

    const listFasilitas = response.data.fasilitas;
    const cekFasilitas = cekJikaItemSudahAdaDalamList(
      listFasilitas,
      formData.fasilitas,
      "fasilitas_id",
      "fasilitas_id"
    );
    if (cekFasilitas.state) {
      return {
        state: false,
        type: "Fasilitas",
        nama: cekFasilitas.data.namaFasilitas,
      };
    }

    const listRikjang = response.data.rikjang;
    const cekRikjang = cekJikaItemSudahAdaDalamList(
      listRikjang,
      formData.rikjang,
      "rikjang_id",
      "rikjang_id"
    );
    if (cekRikjang.state) {
      return {
        state: false,
        type: "Rikjang",
        nama: cekRikjang.data.namaRikjang,
      };
    }

    return {
      state: true,
    };
  };

  return (
    <Modal title='Template' width='70%' show={setShowModal}>
      <Loading show={loading} />
      <ListTemplate
        withForm={false}
        onlySelect={true}
        onlyUnit={true}
        handleClickSelect={handleClickSelect}
      />
    </Modal>
  );
}

const getByFilterTemplate = async (formData) => {
  try {
    const response = await instance3.post(
      "/master/template/get-template-by-penjualan-id",
      {
        id_penjualan: formData.id_penjualan,
        id_template: formData.id_template,
        id_kelas: formData.id_kelas,
        id_asuransi: formData.id_asuransi,
        id_gudang: formData.id_gudang,
        id_unit: formData.id_unit,
        id_doctor: formData.id_doctor,
        nama_doctor: formData.nama_doctor,
      }
    );

    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
        message: "",
      };
    } else {
      return {
        state: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

const getByFilterTemplateTanpaIdPenjualan = async (formData) => {
  try {
    const response = await instance3.post("/master/template/get-template", {
      id_template: formData.id_template,
      id_kelas: formData.id_kelas,
      id_asuransi: formData.id_asuransi,
      id_gudang: formData.id_gudang,
      id_unit: formData.id_unit,
      id_doctor: formData.id_doctor,
      nama_doctor: formData.nama_doctor,
    });

    if (response.data.status === 200) {
      return {
        state: true,
        data: response.data.body,
        message: "",
      };
    } else {
      return {
        state: false,
        message: response.data.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

const errorItemAdaDalamList = (type, name) => {
  defaultToastError(
    `${type} ${name} sudah ada dalam list, hapus terlebih dahulu, jika ingin menggunakan template`
  );
};

const isExist = (arr, key, value) => {
  const fil = arr.filter((item) => item[key] === value);
  return fil;
};

const cekJikaItemSudahAdaDalamList = (arr, arrType, key, value) => {
  let itemYangAdaDalamList = null;
  const check = arr.some((item) => {
    const fil = isExist(arrType, key, item[value]);
    if (fil.length > 0) {
      itemYangAdaDalamList = fil[0];
      return true;
    } else {
      return false;
    }
  });

  return {
    state: check,
    data: itemYangAdaDalamList,
  };
};

export default ModalTemplate;
